/**
 * Local development entry point.
 * In production, AdminApp is loaded as a remote module by the xplatform shell,
 * which owns the MantineProvider so modules inherit its theme on first paint.
 * This standalone entry provides its own provider (from the shared design
 * system) so the module can still be developed in isolation on port 5004.
 */
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { XPlatformProvider } from "@xplatform/design-system";
import "./styles/layers.css";
import "@mantine/core/styles.layer.css";
import "@mantine/charts/styles.layer.css";
import "@mantine/dates/styles.layer.css";
import "@xplatform/design-system/styles.layer.css";
import "@config/i18n";
import AdminApp from "@src/AdminApp";

createRoot(document.getElementById("root")!).render(
    <XPlatformProvider>
        <BrowserRouter>
            <AdminApp />
        </BrowserRouter>
    </XPlatformProvider>
);
